import { useEffect } from 'react'
import isEmpty from 'lodash/isEmpty'

import { useDispatch, useSelector } from 'react-redux'
import { resetFormData, setFormData } from 'store/actions/form'

import hookForms from 'utils/hookForms'
import { getPersistedFormData, persistFormData } from 'utils/formPersistence'

import { FORM } from 'config'
import { FORM as APP_FORM } from 'appConfig/enums'

const triggerOnReset = [FORM.USER_PROFILE_FORM]

// Forms that should persist across tab switches (but not browser close)
const PERSISTABLE_FORMS = [APP_FORM.USER_TASK_FORM]

export default function useFormContainer(name, methods) {
  const formData = useSelector((state: any) => state.form[name])
  const dispatch = useDispatch()

  methods.watch()

  hookForms.addForm(name, methods)

  // On mount, restore form data from sessionStorage if available
  useEffect(() => {
    if (PERSISTABLE_FORMS.includes(name)) {
      const persistedData = getPersistedFormData(name)

      if (persistedData && isEmpty(formData)) {
        // Restore persisted data to Redux store
        dispatch(setFormData({ form: name, data: persistedData }))
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    methods.reset(formData)
    if (!isEmpty(formData) && triggerOnReset.includes(name)) {
      methods.trigger()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData, methods])

  // Persist form data to sessionStorage whenever it changes
  useEffect(() => {
    if (PERSISTABLE_FORMS.includes(name) && !isEmpty(formData)) {
      persistFormData(name, formData)
    }
  }, [formData, name])

  useEffect(() => {
    return () => {
      dispatch(resetFormData({ form: name }))
      // Only clear sessionStorage when form is explicitly closed/submitted, not on unmount
      // This allows data to persist across tab switches
    }
  }, [dispatch, name])
}
